import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X, Play, CreditCard, LogIn, UserPlus, ListChecks } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { useTranslation } from "react-i18next";
import { AutoTranslate } from "@/lib/autoTranslate";

interface MobileNavMenuProps {
  onDemo: () => void;
  onPricing: () => void;
  onSignIn: () => void;
  onGetStarted: () => void;
}

export function MobileNavMenu({ onDemo, onPricing, onSignIn, onGetStarted }: MobileNavMenuProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const handleMenuItemClick = (action: () => void) => {
    action();
    setIsOpen(false);
  };

  return (
    <div className="md:hidden">
      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetTrigger asChild>
          <Button variant="ghost" size="icon" aria-label="Open navigation menu">
            <Menu className="h-5 w-5" />
          </Button>
        </SheetTrigger>
        <SheetContent side="right" className="w-80 p-0 bg-card border-l border-border">
          <div className="flex flex-col h-full">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-border"></div>

            {/* Navigation Items */}
            <div className="flex-1 p-6">
              <div className="grid gap-4">
                <Button
                  variant="ghost"
                  className="w-full justify-start h-14 text-left"
                  onClick={() => handleMenuItemClick(onDemo)}
                >
                  <Play className="h-5 w-5 mr-3" />
                  <div>
                    <div className="font-medium">{AutoTranslate(`Demo`)}</div>
                  </div>
                </Button>

                <Button
                  variant="ghost"
                  className="w-full justify-start h-14 text-left"
                  onClick={() => {
                    setIsOpen(false);
                    setTimeout(() => {
                      document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
                    }, 200);
                  }}
                >
                  <ListChecks className="h-5 w-5 mr-3" />
                  <div>
                    <div className="font-medium">{AutoTranslate(`How It Works`)}</div>
                  </div>
                </Button>

                <Button
                  variant="ghost"
                  className="w-full justify-start h-14 text-left"
                  onClick={() => handleMenuItemClick(onPricing)}
                >
                  <CreditCard className="h-5 w-5 mr-3" />
                  <div>
                    <div className="font-medium">{AutoTranslate(`Pricing`)}</div>
                  </div>
                </Button>

                <Button
                  variant="ghost"
                  className="w-full justify-start h-14 text-left"
                  onClick={() => handleMenuItemClick(onSignIn)}
                >
                  <LogIn className="h-5 w-5 mr-3" />
                  <div>
                    <div className="font-medium">{t('signIn')}</div>
                  </div>
                </Button>

                <Button
                  className="w-full justify-start h-14 text-left"
                  onClick={() => {
                    handleMenuItemClick(onGetStarted);
                  }
                  }
                >
                  <UserPlus className="h-5 w-5 mr-3" />
                  <div>
                    <div className="font-medium">{t('landing.getStarted')}</div>
                  </div>
                </Button>
              </div>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
}
